import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import BenefitsSection from '../../components/feature/BenefitsSection';
import ProcessSection from '../../components/feature/ProcessSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import CTASection from '../../components/feature/CTASection';
import ContactSection from '../../components/feature/ContactSection';
import MapSection from '../../components/feature/MapSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white pb-16 lg:pb-0">
      <Navbar />

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center">
        <div className="absolute inset-0">
          <img src="https://public.readdy.ai/ai/img_res/0a43032129d9db686f5b440a6cc5278e.jpg" alt="Dr. Robin Ellen Leder MD functional medicine doctor Hackensack NJ consultation" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(5,30,25,0.93) 0%, rgba(10,60,48,0.80) 45%, rgba(10,60,48,0.30) 100%)' }}></div>
        </div>
        <div className="relative z-10 w-full px-6 lg:px-12 pt-32 pb-20">
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="inline-block w-8 h-px bg-amber-400"></span>
              <p className="text-amber-400 text-xs font-bold tracking-widest uppercase">Hackensack, NJ · Bergen County · 40+ Years Experience</p>
            </div>
            <h1 className="font-heading text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 leading-tight">
              40 Years of Answers.<br />
              <span className="text-teal-300">Real Results.</span> Real Care.
            </h1>
            <p className="text-teal-100 text-xl mb-4 leading-relaxed max-w-2xl">
              Dr. Robin Ellen Leder, MD brings four decades of functional medicine expertise to Bergen County — delivering root-cause protocols, advanced hormone therapy, and IV chelation care that conventional medicine simply doesn't offer.
            </p>
            <p className="text-amber-400 text-sm font-semibold mb-10 flex items-center gap-2">
              <span>✦</span> Free 10-Minute Phone Consultation — No Obligation
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:2015251155" className="flex items-center justify-center gap-2 bg-white text-teal-900 px-8 py-4 rounded-md text-base font-semibold hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap">
                <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-teal-700 text-lg"></i></div>
                Call (201) 525-1155
              </a>
              <Link to="/contact" className="flex items-center justify-center gap-2 border-2 border-white text-white px-8 py-4 rounded-md text-base font-semibold hover:bg-white hover:text-teal-900 transition-colors cursor-pointer whitespace-nowrap">
                Book Free Consultation
                <div className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-line text-current text-lg"></i></div>
              </Link>
            </div>
            <div className="flex flex-wrap gap-6 mt-10 pt-8 border-t border-teal-800">
              {['40+ Years Experience','Root-Cause Medicine','IV & Chelation Therapy','Free Consultation'].map(t => (
                <div key={t} className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-fill text-teal-400 text-base"></i></div>
                  <span className="text-teal-200 text-sm">{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Floating credential card */}
        <div className="absolute bottom-8 right-8 hidden xl:block">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-5 text-white max-w-xs">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                <i className="ri-award-fill text-white text-lg"></i>
              </div>
              <div>
                <p className="font-semibold text-sm">Dr. Robin Ellen Leder, MD</p>
                <p className="text-teal-300 text-xs">Board-Certified · Hackensack, NJ</p>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2 text-center">
              {[['40+','Years'],['12','Programs'],['NJ','Licensed']].map(([n, l]) => (
                <div key={l} className="bg-white/10 rounded-md p-2">
                  <p className="font-heading font-bold text-base text-amber-400">{n}</p>
                  <p className="text-teal-300 text-xs">{l}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <TrustBar />

      {/* Doctor Authority Bio */}
      <section className="py-20 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
            <div className="relative">
              <div className="relative rounded-lg overflow-hidden">
                <img src="https://images.squarespace-cdn.com/content/v1/589c8fe215d5db3ff221932d/48a78432-3663-46c4-a5f9-e10d46408033/045%5B1%5D+%283%29.jpg" alt="Dr. Robin Ellen Leder MD functional medicine Hackensack NJ" className="w-full h-auto object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-teal-950/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="font-heading font-bold text-white text-lg">Dr. Robin Ellen Leder, MD</p>
                  <p className="text-teal-300 text-sm mb-3">Functional & Integrative Medicine · 40+ Years · Hackensack, NJ</p>
                  <div className="flex flex-wrap gap-2">
                    {['Board-Certified MD','Functional Medicine','IV Chelation','Orthomolecular Psychiatry'].map(tag => (
                      <span key={tag} className="bg-teal-700/80 text-teal-100 text-xs px-2 py-1 rounded">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Credential strip */}
              <div className="mt-4 bg-teal-50 border border-teal-100 rounded-lg p-5">
                <p className="text-xs font-bold text-teal-600 tracking-widest uppercase mb-3">Credentials & Affiliations</p>
                <div className="space-y-2">
                  {[
                    'MD — Board-Certified Physician',
                    '40+ Years Functional & Integrative Medicine',
                    'Orthomolecular Psychiatry & Psychology',
                    'IV Chelation & Nutrient Therapy Specialist',
                    'Hormone & Endocrine Health Expert',
                    'Monthly Author — Bergen County Medical Publications',
                    'Founder, A Better Alternative Medical Center',
                  ].map(c => (
                    <div key={c} className="flex items-start gap-2 text-sm text-teal-800">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-sm"></i>
                      </div>
                      {c}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div>
              <p className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">Meet Dr. Leder</p>
              <h2 className="font-heading text-4xl lg:text-5xl font-bold text-teal-950 mb-6 leading-tight">
                A Doctor Who Actually Listens — And Gets Results
              </h2>
              <div className="space-y-4 text-gray-600 text-base leading-relaxed mb-8">
                <p>For over <strong className="text-teal-900">40 years</strong> at A Better Alternative Medical Center in Hackensack, NJ, Dr. Robin Ellen Leder has helped thousands of patients who've been told "everything looks normal" — yet still feel terrible.</p>
                <p>Her practice is built around one principle: <em>take the time to find real answers.</em> Extended visits, comprehensive functional testing, and deeply personalized protocols uncover the root causes that standard medicine routinely misses.</p>
                <p>Beyond her exceptional diagnostic skills, Dr. Leder brings rare dual expertise — combining functional medicine mastery with a background in <strong className="text-teal-900">psychology and orthomolecular psychiatry</strong>, offering holistic care that addresses both body and mind.</p>
                <p className="font-semibold text-teal-900 text-lg">"If you're tired of being dismissed, this practice was built for you."</p>
              </div>

              <div className="grid grid-cols-3 gap-4 mb-8">
                {[['40+','Years Experience'],['12','Specialized Programs'],['1000s','Patients Helped']].map(([n, l]) => (
                  <div key={l} className="text-center bg-teal-50 rounded-md p-4 border border-teal-100">
                    <p className="font-heading text-3xl font-bold text-teal-800">{n}</p>
                    <p className="text-teal-600 text-xs mt-1">{l}</p>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/about" className="inline-flex items-center justify-center gap-2 bg-teal-700 text-white px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-teal-800 transition-colors cursor-pointer whitespace-nowrap">
                  Full Bio & Credentials
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-white text-base"></i></div>
                </Link>
                <a href="tel:2015251155" className="inline-flex items-center justify-center gap-2 border border-teal-700 text-teal-700 px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap">
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line text-teal-700 text-base"></i></div>
                  Call (201) 525-1155
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTASection variant="mid" />
      <ServicesGrid compact />
      <AIAnswerBlock page="home" />
      <BenefitsSection />
      <CTASection variant="mid" />
      <ProcessSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection variant="bottom" />
      <ContactSection />
      <MapSection />
      <Footer />
    </div>
  );
}
